import type { UserProfile } from '@autobid/strapi-integration/typescript/webapi/User'
import type { AuctionCar } from '@autobid/ui/types/Car'

interface GefcoParams {
  car: AuctionCar
  profile: UserProfile
  categoryNameEng: string
}

export function parseGefcoTransportPayload({
  car,
  profile,
  categoryNameEng,
}: GefcoParams) {
  const { equipments } = car
  const { vehicleDeliveryAddress } = profile.extendedData?.addressBook || {}
  const address = vehicleDeliveryAddress ? profile.extendedData?.addressBook?.items[vehicleDeliveryAddress] : undefined

  const vehicleRoadworthy = Boolean(
    equipments.eq129 && ['2', '3'].includes(equipments.eq129?.value),
  )

  const vehicleHeight = Number(equipments.eq1218?.value)
  const vehicleHeightCode
    = vehicleHeight >= 1860
      ? 'lheight'
      : vehicleHeight > 1700
        ? 'mheight'
        : 'sheight'

  const payload = {
    origin: {
      zip: equipments.eq133.value,
      city: equipments.eq168.value,
      street: equipments.eq164.value,
      country: 114,
    },
    destination: {
      street: address?.address,
      zip: address?.zip,
      city: address?.city,
    },
    carId: car.id,
    vehicleRoadworthy,
    productCode: vehicleHeightCode,
    manufacturer: car.manufacturer.name,
    model: car.name.replace(car.manufacturer.name, '').trim(),
    category: {
      id: car.category.id,
      name: car.category.name,
      name_eng: categoryNameEng,
    },
    tax: 'net',
  }

  return payload
}

interface CevaParams {
  car: AuctionCar
  profile: UserProfile
}

export function parseCevaTransportPayload({
  car,
  profile,
}: CevaParams) {
  const { vehicleDeliveryAddress } = profile.extendedData?.addressBook || {}
  const address = vehicleDeliveryAddress ? profile.extendedData?.addressBook?.items[vehicleDeliveryAddress] : undefined

  const payload = {
    carId: car.id,
    destination: {
      street: address?.address,
      zip: address?.zip,
      city: address?.city,
      country: address?.country.isoCode.toLocaleUpperCase(),
      name: address?.companyName,
    },
    tax: 'net', // for now it should be set statically
  }

  return payload
}
